import React from 'react';
import {Player} from '@lottiefiles/react-lottie-player';

export default function Preloader() {
  const [dots, setDots] = React.useState(1);
  const [interval, setLocalInterval] = React.useState(null);

  React.useEffect(() => {
    function changeNumberOfDots() {
      setDots(dots === 3 ? 0 : dots + 1);
    }
    setLocalInterval(setInterval(() => changeNumberOfDots(), 500));

    return () => {
      if (interval) {
        clearInterval(interval);
      }
    };
  }, [dots]);

  const text = dots === 0 ? '' : '.'.repeat(dots);

  return (
    <div className="fixed" style={{top: '50%', left: '50%', transform: 'translate(-50%, -50%)'}}>
      <Player autoplay loop src="https://assets7.lottiefiles.com/private_files/lf30_e0zgkuc8.json"
        style={{height: '100px', width: '100px'}}/>
      <span className="ml-5">Loading {text}</span>
    </div>
  );
}
